<template>
  <div class="about">
    <!-- 头部 -->
    <zmlmenupage cn-name="货运江湖" en-name="About Us"></zmlmenupage>

    <zmlpagebanner
      banner-img="static/img/aboutBanner.png"
      banner-text="货运江湖，一键启航！"
      cn-name="关于我们"
      en-name="About us"
    >
    </zmlpagebanner>

    <div class="about-jj">
      <div class="info about-jj-info">
        <div class="about-jj-title">货运江湖</div>
        <div class="about-jj-con flex">
          <div class="about-jj-left">
            <div class="about-jj-left-box">
              <div class="about-jj-left-box-title">
                <span>货运江湖</span>简介
              </div>
              <div class="about-jj-left-box-cn">
                <p>
                  货运江湖是广东货多多物流科技股份有限公司旗下领衔开发的水陆多式联运数智化平台。基于
                  5G 互联网、万物互联、云计算、AI
                  大数据、云存储等先进技术，将公路运输和水路运输整合，真正实现了"门到门"的运输。线上车、船、货智能匹配，运输线路规划，全程可视化物流管理，运输过程货流实时监控，运输动态实时预警，完整的信用评价体系。集合同流、货物流、资金流、发票流、信息流五流于一体，为用户提供完整的物流运输服务。
                </p>
              </div>
              <!-- <div class="about-jj-left-box-en">
								<p>Freight Jianghu is an intelligent shipping logistics application led by Guangdong Cargo Logistics Technology Co., Ltd. Based on 5g Internet, Internet of everything, cloud computing, big data and other technologies, freight River</p>
							</div> -->
              <div class="about-jj-left-box-foot">
                <p>找船 找货 找车 就上货运江湖</p>
                <p>水陆多式联运数智化平台</p>
              </div>
            </div>
          </div>
          <div class="about-jj-right">
            <img src="../../static/img/about3.1.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="about-icons">
      <div class="info about-icons-info">
        <div class="about-icons-list flexCenter">
          <div class="about-icons-item flexItems">
            <img src="../../static/img/aboutIcon1.png" width="84" alt="" />
            <div class="about-icons-item-text">
              <p>水陆多式</p>
              <p>联运数智化平台</p>
            </div>
          </div>
          <div class="about-icons-item flexItems">
            <img src="../../static/img/aboutIcon2.jpg" width="84" alt="" />
            <div class="about-icons-item-text">
              <p>便捷的</p>
              <p>交易结算支付工具</p>
            </div>
          </div>
          <div class="about-icons-item flexItems">
            <img src="../../static/img/aboutIcon3.jpg" width="84" alt="" />
            <div class="about-icons-item-text">
              <p>划时代的</p>
              <p>行业信用体系</p>
            </div>
          </div>
          <div class="about-icons-item flexItems">
            <img src="../../static/img/aboutIcon4.jpg" width="84" alt="" />
            <div class="about-icons-item-text">
              <p>互联网</p>
              <p>水陆运输产业生态链</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="about-wh">
      <div class="info about-wh-info">
        <div class="about-wh-box">
          <p>企业文化</p>
          <ul>
            <li>
              <p>价值观</p>
              <p>求实 创新 合作 成就</p>
            </li>
            <li>
              <p>经营理念</p>
              <p>诚信为本 合作共赢</p>
            </li>
            <li>
              <p>企业使命</p>
              <p>IT科技 引领物流创新</p>
            </li>
            <li>
              <p>服务理念</p>
              <p>贴心服务 创行业典范</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- <div class="about-foot">
		<div class="info about-foot-info flexBetween">
				<div class="about-foot-left flexItems">
					<div class="about-foot-left-left">
						<div class="about-foot-left-left-box flexCenter">
							<p>货运</p>
							<p>江湖</p>
						</div>
					</div>
					<div class="about-foot-left-right flexItems">
						<div class="flexItems">
							<div class="about-foot-word flexCenter">零</div>
							<div class="about-foot-text">
								<p>海量货盘，找货不难！</p>
								<p>零空载，就上货运江湖！</p>
							</div>
						</div>
						<div class="flexItems">
							<div class="about-foot-word flexCenter">秒</div>
							<div class="about-foot-text">
								<p>千船待发，运力满满！</p>
								<p>秒接单，就上货运江湖！</p>
							</div>
						</div>
					</div>
				</div>
				<div class="about-foot-right">
					<img src="../../static/img/about4.png" alt="">
				</div>
			</div>
		</div> -->
    <gototop></gototop>
  </div>
</template>
<script>
export default {
  name: "about",
  data() {
    return {};
  },
};
</script>
<style scoped="scoped">
.about-jj {
  width: 100%;
  height: auto;
  background-color: #f4f4f6;
}

.about-jj-info {
  position: relative;
  z-index: 2;
}

.about-jj-title {
  padding-top: 100px;
  font-size: 28px;
  color: #282828;
  font-weight: bold;
}

.about-jj-con {
  margin-top: 50px;
}

.about-jj-left {
  width: 700px;
  background-color: #fff;
  padding: 20px;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
}

.about-jj-left-box {
  width: 660px;
  height: 710px;
  border: 6px solid rgba(244, 244, 246, 1);
  padding: 0px 64px;
  overflow: hidden;
}

.about-jj-left-box-title {
  font-size: 54px;
  color: #282828;
  text-align: center;
  margin-top: 90px;
}

.about-jj-left-box-title span {
  color: #127bfd;
}

.about-jj-left-box-cn {
  color: #666666;
  font-size: 16px;
  line-height: 28px;
  margin-top: 70px;
}

.about-jj-left-box-en {
  color: #787878;
  font-size: 12px;
  line-height: 24px;
  margin-top: 70px;
  font-family: arial;
}

.about-jj-left-box-foot {
  font-size: 20px;
  color: #282828;
  line-height: 36px;
  margin-top: 70px;
  text-align: center;
}

.about-jj-right {
  width: 700px;
  overflow: hidden;
}

.about-jj-right img {
  width: 100%;
}

.about-icons {
  width: 100%;
  height: auto;
  background-color: #fff;
  position: relative;
  z-index: 1;
  margin-top: -200px;
}

.about-icons-info {
  padding-top: 200px;
}

.about-icons-item {
  width: 350px;
  height: 400px;
  border: 1px solid rgba(244, 244, 246, 1);
  padding-left: 20px;
  margin-right: -1px;
}

.about-icons-item-text {
  font-size: 20px;
  color: #282828;
}

.about-wh {
  width: 100%;
  height: 714px;
  background: url(../../static/img/about5.png) no-repeat center;
  background-size: cover;
  position: relative;
  z-index: 3;
  background-attachment: fixed;
}

.about-wh-info {
  position: relative;
}

.about-wh-box {
  width: 350px;
  height: auto;
  background: rgba(18, 123, 253, 1);
  color: #fff;
  padding: 110px 63px 60px 63px;
  position: absolute;
  top: 0;
  right: 0;
}

.about-wh-box > p {
  font-size: 54px;
  text-align: center;
}

.about-wh-box ul li {
  margin-top: 40px;
}

.about-wh-box ul li > p:nth-of-type(1) {
  font-size: 24px;
}

.about-wh-box ul li > p:nth-of-type(2) {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  margin-top: 5px;
}

.about-foot {
  width: 100%;
  height: auto;
  background-color: #fff;
}

.about-foot-info {
  padding: 50px 0 200px;
}

.about-foot-left {
  width: 664px;
  height: auto;
  background: rgba(244, 244, 246, 1);
  padding: 51px 41px;
}

.about-foot-left-left {
  width: 200px;
  height: 200px;
  background: rgba(18, 123, 253, 1);
  padding: 14px;
}

.about-foot-left-left-box {
  width: 100%;
  height: 100%;
  border: 4px solid rgba(255, 255, 255, 1);
  color: #fff;
  font-size: 54px;
  text-align: center;
  flex-flow: column;
}

.about-foot-left-right {
  padding-left: 28px;
  flex-flow: column;
}

.about-foot-left-right > div {
  margin: 14px 0;
}

.about-foot-word {
  width: 76px;
  height: 76px;
  border: 3px solid rgba(18, 123, 253, 1);
  border-radius: 50%;
  color: #127bfd;
  font-size: 39px;
  margin-right: 15px;
}

.about-foot-text {
  font-size: 20px;
  color: #282828;
  line-height: 28px;
}

.about-foot-right {
  width: 664px;
  height: auto;
}

.about-foot-right img {
  width: 100%;
}

@media only screen and (max-width: 750px) {
  .info {
    padding: 0px 23px;
  }
  .aboutBanner {
    display: none;
  }
  .about-jj-left,
  .about-jj-right,
  .about-jj-left-box,
  .about-foot-left {
    width: 100%;
  }
  .about-jj-con {
    display: block;
    margin-top: 20px;
  }
  .about-icons-list {
    flex-wrap: wrap;
  }
  .about-icons-item {
    width: 50%;
    padding-left: 0;
    height: auto;
    padding: 30px 0;
  }
  .about-icons-item img {
    width: 42px !important;
  }
  .about-icons-item-text {
    font-size: 14px;
  }
  .about-jj-title {
    font-size: 14px;
    font-weight: bold;
    padding-top: 50px;
  }
  .about-jj-left {
    padding: 10px;
  }
  .about-jj-left-box {
    padding: 15px;
    height: auto;
  }
  .about-jj-left-box-title {
    font-size: 40px;
    margin-top: 30px;
  }
  .about-jj-left-box-cn {
    margin-top: 20px;
    font-size: 14px;
  }
  .about-jj-left-box-en,
  .about-jj-left-box-foot {
    margin-top: 35px;
  }
  .about-jj-right {
    margin-top: 35px;
  }
  .about-icons {
    /* margin-top: 0; */
    padding-top: 200px;
  }
  .about-wh {
    height: 425px;
  }
  .about-wh .info {
  }
  .about-wh-box {
    width: 175px;
    padding: 20px;
    height: auto;
    right: 23px;
  }
  .about-wh-box > p {
    font-size: 27px;
  }
  .about-wh-box ul li {
    margin-top: 20px;
  }
  .about-wh-box ul li > p:nth-of-type(1) {
    font-size: 16px;
  }
  .about-wh-box ul li > p:nth-of-type(2) {
    font-size: 13px;
  }
  .about-foot {
    padding-top: 30px;
    padding-bottom: 140px;
  }
  .about-foot-info {
    display: block;
  }
  .about-foot-left {
    display: block;
    padding: 25px 12px;
  }
  .about-foot-right {
    width: 100%;
    margin-top: 20px;
  }
  .about-foot-left-left {
    width: 100px;
    height: 100px;
    padding: 7px;
    margin: auto;
  }
  .about-foot-left-left-box {
    font-size: 27px;
  }
  .about-foot-left-right {
    padding-left: 0px;
    margin-top: 20px;
  }
  .about-foot-left-right > div {
    margin: 7px 0;
  }
  .about-foot-word {
    width: 38px;
    height: 38px;
    border: 1px solid rgba(18, 123, 253, 1);
    font-size: 13px;
    margin-right: 15px;
  }
  .about-foot-text {
    font-size: 13px;
    color: #282828;
    line-height: 22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/about.vue